import React, { useState, useEffect } from 'react';
import Button from '../../../components/Button/Button';
import IndentedDropdown from '../../../components/IndentedDropdown/IndentedDropdown';
import InputField from '../../../components/InputField/InputField';
import { FiDownload } from 'react-icons/fi';
import { PTable, InputLabel } from './styles';
import {
  getParties,
  getProducts,
  getSalesReport,
  getSites,
  getStockOnHandReport,
  getUsers
} from '../../../api';
import ButtonSecondary from '../../../components/Button/ButtonSecondary';
import Select from 'react-select';

const StockOnHandScreen = () => {
  const [toDate, setToDate] = useState();
  const [tableData, setTableData] = useState([]);
  const [products, setProducts] = useState([]);
  const [parties, setParties] = useState([]);
  const [sites, setSites] = useState([]);
  const [party, setParty] = useState();
  const [site, setSite] = useState();
  const [product, setProduct] = useState(-1);

  const productSelected = (e) => {
    setProduct(e.value);
  };

  useEffect(() => {
    getParties(null, true, true).then(({ data }) => {
      const partiesToSelect = [{ key: 'All', value: 0 }];
      partiesToSelect.push(
        ...data.map((party) => {
          return {
            key: party.name,
            value: party.id
          };
        })
      );
      setParties(partiesToSelect);
    });

    getProducts().then(({ data }) => {
      const productToSelect = [{ label: 'All', value: 0 }];
      productToSelect.push(
        ...data.map((product) => {
          return {
            value: product.id,
            label: product.name
          };
        })
      );
      setProducts(productToSelect);
    });
  }, []);

  useEffect(() => {
    if (!party) {
      setSites([]);
      return;
    }
    getSites(party).then(({ data }) => {
      const sitesToSelect = [{ key: 'All', value: 0 }];
      sitesToSelect.push(
        ...data.map((site) => {
          return {
            key: site.name,
            value: site.id
          };
        })
      );
      setSites(sitesToSelect);
    });
  }, [party]);

  const getReport = async (download) => {
    if (!toDate) {
      alert('Please select a date to report to');
      return;
    }

    if (!site || site < 0) {
      alert('Please select a site');
      return;
    }

    if (!party || party < 0) {
      alert('Please select a client');
      return;
    }

    if (product < 0) {
      alert('Please select a product');
      return;
    }

    const { data } = await getStockOnHandReport(
      party,
      site,
      product,
      toDate,
      download
    );
    if (download) {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `Stock On Hand Report ${toDate}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      setTableData(data.data);
      if (data.data.length == 0) {
        alert('No results');
      }
    }
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#f5f5f5',
          padding: '10px 0'
        }}
      >
        <InputLabel>
          <label>Party</label>
          <IndentedDropdown
            placeholder='Party'
            icon='user'
            options={parties}
            onChange={(e) => setParty(e.target.value)}
            value={party}
          />
        </InputLabel>
        <InputLabel>
          <label>Site</label>
          <IndentedDropdown
            placeholder='Site'
            icon='user'
            options={sites}
            onChange={(e) => setSite(e.target.value)}
            value={site}
          />
        </InputLabel>
        <InputLabel>
          <label>Product</label>
          <Select
            options={products}
            placeholder='Search'
            onChange={productSelected}
            styles={{
              control: (styles) => ({
                ...styles,
                minWidth: 250,
                backgroundColor: '#e0e0e0',
                border: 'none',
                borderRadius: 12,
                padding: 5
              })
            }}
          />
        </InputLabel>
        <InputLabel>
          <label>Date</label>
          <InputField
            type='date'
            customStyle={{ minWidth: 250 }}
            onChange={(val) => setToDate(val.target.value)}
          />
        </InputLabel>
      </div>
      <div className='action-buttons'>
        <Button title='Generate' onClick={() => getReport()} />
        <ButtonSecondary
          title='Download .csv'
          onClick={() => getReport(true)}
        />
      </div>

      <PTable>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Date Received</th>
              <th>Delivery Note</th>
              <th>Site Owner</th>
              <th>Site</th>
              <th>Product</th>
              <th>Product Description</th>
              <th>Lot</th>
              <th>Expiry Date</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row) => {
              return (
                <tr>
                  <td>{row.Date}</td>
                  <td>{row['Date Received']}</td>
                  <td>{row['Delivery Note']}</td>
                  <td>{row['Site Owner']}</td>
                  <td>{row.Site}</td>
                  <td>{row.Product}</td>
                  <td>{row['Product Desc']}</td>
                  <td>{row.Lot}</td>
                  <td>{row['Expiry Date']}</td>
                  <td>{row.Quantity}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </PTable>
    </>
  );
};

export default StockOnHandScreen;
